export default __webpack_public_path__ + "static/media/Helmet.a561e130.gltf";